import { Injectable } from '@angular/core';
import { ITabsSettings } from '@fi-app/utilities/tabs/tabs-module-base';
import { BehaviorSubject, Observable, ReplaySubject } from 'rxjs';
import { ListData } from '@fi-app/components/items-list/list-data.service';

@Injectable()
export class TabsModuleService {
    private _tabsSettings: ITabsSettings;
    get tabsSettings() {
        return this._tabsSettings;
    }

    constructor() {}

    resetTabsSettings() {
        this._tabsSettings = {
            listData: undefined,
            disableAdd: false,
        };
        this._tabsListData$.next(this._tabsSettings.listData);
    }

    setTabsSettings(tabsSettings: ITabsSettings) {
        setTimeout(() => {
            this._tabsSettings = tabsSettings;
            this._tabsListData$.next(this._tabsSettings.listData);
        });
    }

    private _tabsListData$ = new ReplaySubject<ListData<any>>(1);
    get tabsListData$() {
        return this._tabsListData$.asObservable();
    }
}
